/**
 * Theme Toggle for Ritmo Design System
 * 
 * This script adds functionality to toggle between light and dark themes
 * using the Ritmo design tokens.
 */

class ThemeToggle {
  constructor() {
    this.init();
  }

  init() {
    // Check for saved theme preference or use system preference
    const savedTheme = localStorage.getItem('theme');
    
    if (savedTheme) {
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }

    // Initialize toggle buttons after DOM is fully loaded
    document.addEventListener('DOMContentLoaded', () => {
      this.initializeToggles();
    });
  }

  initializeToggles() {
    const toggleButtons = document.querySelectorAll('.js-theme-toggle');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const currentTheme = document.documentElement.getAttribute('data-theme');
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
        
        // Update toggle button labels
        this.updateToggleLabels(newTheme);
      });
      
      // Set initial state
      this.updateToggleLabels(document.documentElement.getAttribute('data-theme'));
    });
  }

  updateToggleLabels(theme) {
    const toggleButtons = document.querySelectorAll('.js-theme-toggle');
    
    toggleButtons.forEach(button => {
      const lightLabel = button.querySelector('.theme-toggle__light-label');
      const darkLabel = button.querySelector('.theme-toggle__dark-label');
      
      if (lightLabel && darkLabel) {
        if (theme === 'dark') {
          lightLabel.classList.add('hidden');
          darkLabel.classList.remove('hidden');
        } else {
          lightLabel.classList.remove('hidden');
          darkLabel.classList.add('hidden');
        }
      }
    });
  }
}

// Initialize theme toggle
new ThemeToggle();
